class Renderer
{
    protected canvas: HTMLCanvasElement;
    protected canvasCtx: CanvasRenderingContext2D;

    constructor(canvas: HTMLCanvasElement)
    {
        this.canvas = canvas;
        this.canvasCtx = canvas.getContext('2d');
    }

}

export default Renderer;